import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { GetPartnerAccountGroupMappingResponseInterface, PartnerAccountGroupService } from '@galaxy/partner';
import { inject, Injectable } from '@angular/core';
import { BusinessInfoService } from '../../../../business-info.service';

export interface AccountMappingReturnInterface {
  success: boolean;
  error: string;
}

@Injectable()
export class EditPartnerIdDialogService {
  private readonly partnerAccountGroupService = inject(PartnerAccountGroupService);
  private readonly businessInfoService = inject(BusinessInfoService);

  getAccountGroupForPID(partnerID: string): Observable<GetPartnerAccountGroupMappingResponseInterface> {
    return this.partnerAccountGroupService
      .getPartnerAccountGroupMapping(partnerID, null)
      .pipe(map((accountInfo) => (accountInfo ? accountInfo : null)));
  }

  getCompanyName(accountGroupId: string): Observable<string> {
    return this.businessInfoService.getBusinessData(accountGroupId).pipe(
      map((businessInfo) => {
        return businessInfo ? businessInfo.name : '';
      }),
      catchError(() => {
        return of('');
      }),
    );
  }

  swapAccountGroup(
    partnerID: string,
    accountGroupId: string,
    withPartnerID: string,
    withAccountGroupId: string,
  ): Observable<AccountMappingReturnInterface> {
    return this.partnerAccountGroupService
      .swapPartnerAccountGroup(partnerID, accountGroupId, withPartnerID, withAccountGroupId)
      .pipe(
        map((success) => {
          return { success: success, error: '' };
        }),
        catchError((error) => {
          return of({ success: false, error: error?.error?.message });
        }),
        take(1),
      );
  }

  updateAccountGroup(partnerID: string, accountGroup: string): Observable<AccountMappingReturnInterface> {
    return this.partnerAccountGroupService.updatePartnerAccountGroup(partnerID, accountGroup).pipe(
      map((success) => {
        return { success: success, error: '' };
      }),
      catchError((error) => {
        return of({ success: false, error: error?.error?.message });
      }),
      take(1),
    );
  }
}
